import DataTableCell_default from "./DataTableCell.vue.js";
import { createBlock, defineComponent, mergeProps, openBlock, renderSlot, unref, withCtx } from "vue";
import { useBindCx } from "@scalar/use-hooks/useBindCx";
//#region src/v2/components/data-table/DataTableHeader.vue?vue&type=script&setup=true&lang.ts
var DataTableHeader_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	__name: "DataTableHeader",
	setup(__props) {
		const { cx } = useBindCx();
		return (_ctx, _cache) => {
			return openBlock(), createBlock(DataTableCell_default, mergeProps({ is: "th" }, unref(cx)("items-center font-medium px-2 min-w-0 -outline-offset-1")), {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 16);
		};
	}
});
//#endregion
export { DataTableHeader_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=DataTableHeader.vue.script.js.map